import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { Button } from 'primeng/button';
import { NotificationService } from '../../shared/service/notification.service';
import { Registration } from '../models/registration';
import { RegistrationService } from '../registration.service';

@Component({
  selector: 'app-additional-info',
  templateUrl: './additional-info.component.html',
  styleUrl: './additional-info.component.scss'
})
export class AdditionalInfoComponent {

  @Input() registration!: Registration;

  public aggrementConfirmation: boolean = false;

  constructor(
    private readonly registrationService: RegistrationService,
    private readonly notificationService: NotificationService
  ) { }

  getFormUrl(btn: Button): void {
    btn.loading = true;

    this.registrationService.getFormUrl(this.registration.id ?? 0)
      .subscribe({
        next: (response) => {
          if (response && response.formUrl) {
            globalThis.open(response.formUrl, "_blank");
          } else {
            this.notificationService.error({ message: 'There was an issue retrieving the Waiver Form details. Please try again.' });
          }

          btn.loading = false;
        },
        error: (err: HttpErrorResponse) => {
          btn.loading = false;
          this.notificationService.error(err);
        }
      });
  }

}
